<template>
<div class="chapter">
<div class="inner_page">
<p class="copyrightt"><a id="page_iv"></a>Farrar, Straus and Giroux</p>
<p class="copyright">18 West 18th Street, New York 10011</p>
<p class="copyright"> </p>
<p class="copyright">Copyright © 2008 by Frances Wilson</p>
<p class="copyright">Map copyright © András Bereznay</p>
<p class="copyright">All rights reserved</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">Originally published in 2008 by Faber and Faber Limited, Great Britain</p>
<p class="copyright">Published in the United States by Farrar, Straus and Giroux</p>
<p class="copyright">First American edition, 2009</p>
<p class="copyright"> </p>
<p class="copyright">Owing to limitations of space, illustration credits appear on page 317.</p>
<p class="copyright"> </p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Wilson, Frances, 1964–</p>
<p class="copyright2">The ballad of Dorothy Wordsworth : a life / Frances Wilson. —1st American ed.</p>
<p class="copyright2">    p. cm.</p>
<p class="copyright2">Includes bibliographical references and index.</p>
<p class="copyright2">“Originally published in 2008 by Faber and Faber Limited, Great Britain”—T.p. verso.</p>
<p class="copyright2">ISBN-13: 978-0-374-10867-0 (alk. paper)</p>
<p class="copyright2">ISBN-10: 0-374-10867-6 (alk. paper)</p>
<p class="copyright2">1. Wordsworth, Dorothy, 1771–1855. 2. Wordsworth, William, 1770–1850—Family. 3. Authors, English—19th century—Biography. 4. Women and literature—England—History—19th century. I. Title.</p>
<p class="copyright3">PR5849.W55 2009</p>
<p class="copyright3">828'.703—dc22</p>
<p class="copyright3">[B]</p>
<p class="copyright4">2008041263</p>
<p class="copyright"><em class="italic">Designed by Michelle McMillian</em></p>
<p class="copyright"> </p>
<p class="copyright"><a href="http://www.fsgbooks.com" target="_blank">www.fsgbooks.com</a></p>
<p class="copyright"> </p>
<p class="copyright">1   3   5   7   9   10   8   6   4   2</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?3f2b1695